import React from "react";
import DatePicker from "react-datepicker";
import {setHours, setMinutes, setSeconds} from "date-fns";
import useSingleHours from "../hooks/useSingleHours";
import _ from 'underscore';
import { Dash } from "../styled_components/exporter";
import { minStart, minEnd, maxStart } from "../utility/minMaxTime";
import TimeSelect from "../../../components/TimeSelect";

const uuid = _.uniqueId;

// eslint-disable-next-line no-unused-vars
const SingleHour = ({ hourly, handleHours, reference, anytime }) => {
  const {
    currentValStart,
    handleCurrentValStart,
    currentValEnd,
    handleCurrentValEnd
  } = useSingleHours({ hourly, handleHours });

  /**
   * Fixed a bug where a newly added opening time (mode: "daily") would not display the 
   * seleted DatePicker value as it said selected={!anytime && currentValStart} [/End]
   */
  let uid= uuid();
  return (
    <>
        <TimeSelect
            minTime={minStart(reference)}
            maxTime={maxStart(currentValEnd)}
            step={15}
            changeHandler={handleCurrentValStart}
            extraClasses={"width_75"}
            value={currentValStart}
            uid={uid}
        />
     {/* <DatePicker
        selected={currentValStart}
        onChange={date => handleCurrentValStart(date)}
        onKeyDown={e => e.preventDefault()}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeFormat="HH:mm"
        minTime={minStart(reference)}
        maxTime={maxStart(currentValEnd)}
        dateFormat="HH:mm"
      />*/}
      <div key={uid} className="react-datepicker-wrapper">
        <div className="react-datepicker__input-container">
          <Dash>&mdash;</Dash>
        </div>
      </div>
        <TimeSelect
            minTime={minEnd(reference, currentValStart)}
            maxTime={setHours(setMinutes(setSeconds(new Date(), 59), 59),23)}
            step={15}
            changeHandler={handleCurrentValEnd}
            extraClasses={"width_75"}
            value={currentValEnd}
            uid={uid}
        />
      {/*<DatePicker
        selected={currentValEnd}
        onChange={date => handleCurrentValEnd(date)}
        onKeyDown={e => e.preventDefault()}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeFormat="HH:mm"
        minTime={minEnd(reference, currentValStart)}
        maxTime={setHours(setMinutes(new Date(), 45), 23)}
        dateFormat="HH:mm"
      />*/}
    </>
  );
};

export default SingleHour;
